import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const OcrCamsIntegrationService = {
    list: () => axios.get(API_KEEPER + "/integrations/web/all").then(({ data }) => data).catch((err) => { throw err }),

    save: (integration, data) => axios.post(API_KEEPER + "/integrations/web/save/" + integration, data).then(({ data }) => data).catch((err) => { throw err }),

    import: (integration, file) => axios.post(API_KEEPER + "/integrations/web/lane/import/" + integration, file, {
        headers: {'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',}
    }).catch((err) => { throw err }),
};

export default OcrCamsIntegrationService;